import type { Status } from '@/components/status-badge';

export function cpuStatus(cpu: number | null): Status {
  if (cpu === null) return 'unknown';
  if (cpu < 60) return 'healthy';
  if (cpu < 80) return 'warning';
  return 'critical';
}

export function ec2InstanceStatus(state: string): Status {
  if (state === 'running') return 'healthy';
  if (state === 'pending' || state === 'stopping') return 'warning';
  return 'critical';
}
